export const DIAL_TYPES = {
  CURRENT: "current",
  PACING: "pacing"
};

export const dials = [
  {
    type: DIAL_TYPES.CURRENT,
    number: 1
  },
  {
    type: DIAL_TYPES.PACING,
    number: 2
  }
];
